import UI from './ui-base';
import { toHTML, dataSetToObject } from '../util/dom-util';
import EventHandler from '../_dependencyvendor/event-handler';

// eslint-disable-next-line no-unused-vars
const VERSION = '0.0.1';
const NAME = 'ui.rslider';

// data-attribute 로 설정 가능한 옵션 들
const dataAttrConfig = {};

const defaultConfig = {
  ...dataAttrConfig,
};

class RangeSlider extends UI {
  constructor(element, config = {}) {
    super(element, config);
    this._setupConfog(config);
    this._fake = null;
    this._input = null;
    this._handle = null;
    this._fill = null;
    this._currentValue = 0;
    this._init();
  }

  static get EVENT() {
    return {
      CHANGE: `${NAME}.change`,
    };
  }

  static get NAME() {
    return NAME;
  }

  /**
   * 삭제
   */
  destroy() {
    this._removeEvents();
    this._removeVars();
    super.destroy();
  }

  _setupConfog(config) {
    this._config = {
      ...defaultConfig,
      ...config,
      ...dataSetToObject(this._element, dataAttrConfig, 'rslider'),
    };
  }

  /**
   * 필요에 따라 public으로..
   */
  _init() {
    this._createElements();
    this._initVars();
    this._initEvents();

    this._currentValue = (this._input.value / this._input.max) * 100;
    this._render(this._currentValue);
  }

  /**
   * 변수 초기화
   */
  _initVars() {
    this._input = this._element.querySelector('input[type="range"]');
    this._handle = this._element.querySelector('.range-fake__handle');
    this._fill = this._element.querySelector('.range-fake__fill');
  }

  /**
   * 이벤트 초기화
   */
  _initEvents() {
    EventHandler.on(this._input, super._eventName('input'), e => {
      this._currentValue = e.target.value;
      const per = (e.target.value / e.target.max) * 100;
      EventHandler.trigger(this._element, RangeSlider.EVENT.CHANGE, {
        value: this._currentValue,
      });
      this._render(per);
    });
  }

  /**
   * 변수 초기화
   */
  _removetVars() {
    this._element.removeChild(this._fake);
    this._input = null;
    this._handle = null;
    this._fill = null;
    this._fake = null;
    this._currentValue = 0;
    this._config = null;
    this._element = null;
  }

  /**
   * 이벤트 초기화
   */
  _removeEvents() {
    EventHandler.off(this._input, super._eventName('input'));
  }

  _render(per) {
    this._handle.style.left = `${per}%`;
    this._fill.style.width = `${per}%`;
  }

  _createElements() {
    const template = `
      <div class="range-fake">
        <span class="range-fake__bg"></span>
        <span class="range-fake__fill"></span>
        <button type="button" class="range-fake__handle left"></button>
      </div>
    `;
    this._fake = toHTML(template);
    this._element.appendChild(this._fake);
  }
}

export default RangeSlider;
